import Fuse from 'fuse.js';

import links from '../data/links';

const fuse = new Fuse(Object.values(links), {
  keys: [
    {
      name: 'title',
      weight: 0.4,
    },
    {
      name: 'keywords',
      weight: 0.4,
    },
    {
      name: 'link',
      weight: 0.2,
    },
  ],
  shouldSort: true,
  tokenize: true,
  matchAllTokens: true,
  threshold: 0.2,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
});

function fuseSearch({ term }) {
  return fuse.search(term.trim());
}

function userSearch({ term }) {
  function getUser(word) {
    const parts = word.split('.');

    if (parts.length !== 2) return {};

    const userID = Number(parts[0]);

    if (Number.isNaN(userID)) return {};

    const appID = parts[1];

    if (appID.length === 0) return {};

    const appParts = appID.split('_');

    if (appParts.length !== 2 && appID !== 'testap1')
      return {
        title: 'Search User in Production',
        link: `https://support.gamegos.net/${appID}/users/${userID}/info`,
      };

    if (!appParts.every(el => el.length)) return {};

    return {
      title: 'Search User in Beta',
      link: `https://support-beta.gamegos.net/${appID}/users/${userID}/info`,
    };
  }

  const words = term.split(' ');

  const users = words.map(getUser).filter(el => Object.hasOwn(el, 'link'));

  if (!users.length) return null;

  if (users.length === 1) return users[0];

  return users.reduce(
    (a, c) => ({
      ...a,
      links: [...a.links, c.link],
    }),
    { title: 'Search Multiple Users', links: [] }
  );
}

const middleWares = [userSearch, fuseSearch];

function applyMiddleware({ term }) {
  return func => func({ term });
}

export default function search({ term }) {
  const results = middleWares.map(applyMiddleware({ term }));

  return results
    .filter(el => !!el)
    .reduce((a, c) => {
      if (Array.isArray(c)) return [...a, ...c];

      return [...a, c];
    }, []);
}
